/**
 * スムーススクロール要素を生成  
 * 
 * **[使い方]**  
 * `const hoge = SmoothScrollAnchor(targetEl, options)`
 * 
 * @param HTMLSelector anchorEl アンカーとなる要素のセレクター。初期値：`a[href^="#"]`
 * @param Object options
 */
function SmoothScrollAnchor(targetEl = 'a[href^="#"]', options = {}) {
  if(!!document.querySelectorAll(targetEl).length == false) {
    console.error('Elements "' + targetEl + '" no exists.');
    return false;
  }

  // 初期設定
  const initialSetting = {
    additionalBufferTarget: {
      targetEl: 'js-fadeIn',
      matchEl: 'inview',
    },
    /**
     * スクロールの挙動  
     * *default - `smooth`*
     * @value string
     */
    behavior: 'smooth',
    /**
     * スクロール後のページ上部の余白  
     * `px`単位で記述  
     * *default - `70`(px)*
     * @value number
     */
    buffer: 70,
    /**
     * ヘッダーSelector  
     * *default - `.c-header`*
     * @value HTMLSelector
     */
    headerEl: '.c-header',
    /**
     * ヘッダーの高さを考慮するか  
     * *default - `true`*
     */
    isFixedHeader: true,
  };
  // merge client settings
  const setting = {...initialSetting, ...options};
  // console.log(setting)



  init();// 初期化処理

  function init() {
    const anchors = document.querySelectorAll(targetEl);
    const settingHeaderHeight = (
      setting.isFixedHeader &&
      document.querySelector(setting.headerEl)
    ) ? document.querySelector(setting.headerEl).offsetHeight : 0;
    const settingBuffer = setting.buffer;

    // 各 anchor にクリックイベント
    for ( let i = 0; i < anchors.length; i++ ) {
      anchors[i].addEventListener('click', (e) => {
        e.preventDefault();
        const href= anchors[i].getAttribute("href");
        let smoothScrollFadeInBuffer = 0;

        // topに戻る以外のアンカー
        if (href !== '#') {

          // スクロール先の要素を取得
          const target = document.getElementById(href.replace('#', ''));

          if(!target) return false;
          if(
            target.classList.contains(setting.additionalBufferTarget.targetEl) && 
            !target.classList.contains(setting.additionalBufferTarget.matchEl)
          ) {
            smoothScrollFadeInBuffer = 50;
          }

          const position = window.scrollY + target.getBoundingClientRect().top - settingHeaderHeight - settingBuffer - smoothScrollFadeInBuffer;

          // スクロールアニメーション
          window.scroll({
            top: position,
            behavior: setting.behavior
          });

        } else {
          // ページトップへスクロール
          window.scroll({
            top: 0,
            behavior: setting.behavior
          });

        }
      });
    }
    console.log('initial SmoothScrollAnchor')
  }
}


const smoothAnchor = SmoothScrollAnchor();